import { Component, OnInit, OnDestroy } from "@angular/core";
import { Router, Event as NavigationEvent } from "@angular/router";
import { filter, takeUntil } from "rxjs/operators";
import { NavigationStart } from "@angular/router";
import { Subject, Subscription } from "rxjs";
import { MuestraService } from '../modulo-comunes/servicios/muestra-servicios';
import { LogService } from "../modulo-comunes/servicios/log-servicios";

@Component({
  selector: "sitio-publico",
  templateUrl: "./sitio-publico.component.html",
  styleUrls: ["./sitio-publico.component.css"]
})
export class SitioPublicoComponent implements OnInit, OnDestroy {
  private _onDestroy$: Subject<void> = new Subject();
  title = '...';
  //La navegación original tiene un problema: cuando la página de origen está en una posición Y, al ir por el menú
  //a una página destino, va a la misma posición Y. Esto hace confusa la navegación. Para solucionar hice esto:
  //1.- creé un id="top" en el div al inicio de cada página y navegué a una ruta con fragment="top". Funciona pero la
  //parte superior de la página queda tapada por el menú. 1.1.- Añadí tres <br> dentro del div, pero ahora al hacer scroll
  //se ve un espacio en blanco muy grande arriba del texto inicial
  //2.- detecté el evento de navegación aquí en AppComponent y puse un window.scroll(0,0), funciona para las navegaciones
  //por menú, pero también manda al inicio cuando hago Precios -> Módulo (ej. Roles) -> regresar
  //3.- intenté hacer un array de navegaciones y poder regresar siempre a la posición donde estaba, pero la navegación
  //puede ser muy compleja, no es simplemente push y pop, se crea una ruta incluso por cada Back y el router tiene
  //sus propias reglase de cómo navegar y es difícil saber a qué navegación regresar... ver esto:
  //(https://www.bennadel.com/blog/3533-using-router-events-to-detect-back-and-forward-browser-navigation-in-angular-7-0-4.htm)
  //https://github.com/angular/angular/issues/10929
  //4.- simplifico: solo guardo dos datos de navegación: anteriorNav y actualNav y solo dos datos: si es navegación imperativa
  //(o sea click en un enlace) o popstate (o sea back). Siempre antes de leer la actual guardo la actualNav como anteriorNav.
  //luego leo la actual. Si es popstate, veo si la anterior era también popstate. Si lo era retorno a (0,0) y si no lo era,
  //retorno a anteriorNav.posOrigen. Si es imperativa, voy a (0,0). Por suerte esto no afecta a imperativas con fragment
  //PROBLEMA: En Inicio botón Contáctanos y en Precios link Efisys Móvil, al ir y regresar no vuelve a la posición original.
  anteriorNav = { trigger: "imperativa", posOrigen: 0 };
  actualNav = { trigger: "imperativa", posOrigen: 0 };

  muestraOfflineSub: Subscription;
  muestraOffline: boolean = false;
  muestraLoadingSub: Subscription;
  muestraLoading: boolean = false;
  muestraMsgboxSub: Subscription;
  muestraMsgbox: boolean = false;
  muestraComboSub: Subscription;
  muestraCombo: boolean = false;
  muestraDatepickSub: Subscription;
  muestraDatepick: boolean = false;
  muestraDropdownSub: Subscription;
  muestraDropdown: boolean = false;
  muestraSelectboxSub: Subscription;
  muestraSelectbox: boolean = false;

  constructor(
    private router: Router,
    private muestraService: MuestraService,
    private logService: LogService
  ) { }

  ngOnInit() {
    this.muestraOfflineSub = this.muestraService.offline$
      .pipe(takeUntil(this._onDestroy$))
      .subscribe(p => {
        this.muestraOffline = p;
      })

    this.muestraLoadingSub = this.muestraService.loading$
      .pipe(takeUntil(this._onDestroy$))
      .subscribe(p => {
        this.muestraLoading = p;
      })

    this.muestraService.muestraLoading(false);

    this.muestraMsgboxSub = this.muestraService.msgbox$
      .pipe(takeUntil(this._onDestroy$))
      .subscribe(p => {
        this.muestraMsgbox = p;
      })

    this.muestraService.ocultaMsgbox('');

    this.muestraComboSub = this.muestraService.combo$
      .pipe(takeUntil(this._onDestroy$))
      .subscribe(p => {
        this.muestraCombo = p;
      })

    this.muestraService.ocultaCombo('', '.');

    this.muestraDatepickSub = this.muestraService.datepick$
      .pipe(takeUntil(this._onDestroy$))
      .subscribe(p => {
        this.muestraDatepick = p;
      })

    this.muestraService.ocultaDatepick('', '.');

    this.muestraDropdownSub = this.muestraService.dropdown$
      .pipe(takeUntil(this._onDestroy$))
      .subscribe(p => {
        this.muestraDropdown = p;
      })

    this.muestraService.ocultaDropdown(999, '.');

    this.muestraSelectboxSub = this.muestraService.selectbox$
      .pipe(takeUntil(this._onDestroy$))
      .subscribe(p => {
        this.muestraSelectbox = p;
      })

    this.muestraService.ocultaSelectbox('');

    this.router.events
      .pipe(
        filter((event: NavigationEvent) => {
          return event instanceof NavigationStart;
        })
      )
      .subscribe((event: NavigationStart) => {
        this.anteriorNav.trigger = this.actualNav.trigger;
        this.anteriorNav.posOrigen = this.actualNav.posOrigen;
        this.actualNav.trigger = event.navigationTrigger;
        this.actualNav.posOrigen = window.pageYOffset;
        /*
        console.group("NavigationStart Event");
        this.logService.consoleLog('2', "PC CO ruta:")
        this.logService.consoleLog('2', "PC CO " + {"id":event.id,"destino":event.url,"trigger":event.navigationTrigger,"pos origen":window.pageYOffset});
        this.logService.consoleLog('2', "PC CO anterior:")
        this.logService.consoleLog('2', "PC CO " + this.anteriorNav)
        this.logService.consoleLog('2', "PC CO actual:")
        this.logService.consoleLog('2', "PC CO " + this.actualNav)
        this.logService.consoleLog('2', "PC CO navigation id:", event.id);
        this.logService.consoleLog('2', "PC CO route:", event.url);
        this.logService.consoleLog('2', "PC CO trigger:", event.navigationTrigger);
        this.logService.consoleLog('2', "PC CO Y:", window.pageYOffset);
        */
        if (event.restoredState) {
          console.warn(
            "restoring navigation id:",
            event.restoredState.navigationId
          );
          if (this.anteriorNav.trigger == "popstate") {
            this.anteriorNav.posOrigen = 0;
            this.actualNav.posOrigen = 0;
            /*
            this.logService.consoleLog('2', "PC CO anterior2:")
            this.logService.consoleLog('2', "PC CO " + this.anteriorNav)
            this.logService.consoleLog('2', "PC CO actual2:")
            this.logService.consoleLog('2', "PC CO " + this.actualNav)
            */
          }
          /*
          this.logService.consoleLog('2', "PC CO Retorno a: ");
          this.logService.consoleLog('2', "PC CO " + this.anteriorNav.posOrigen);
          */
          window.scroll(0, this.anteriorNav.posOrigen);
        } else {
          window.scroll(0, 0);
        }
        //console.groupEnd();
      });
  }

  /*
  ngOnInit(){

    router.events.subscribe(event => {
      this.logService.consoleLog('2', "PC CO " + event);
      //this.logService.consoleLog('2', "PC CO " + event.routerEvent);
      if(event.routerEvent!=undefined){
          this.logService.consoleLog('2', "PC CO " + event.anchor);
          this.logService.consoleLog('2', "PC CO " + event.navigationTrigger);
          if(event.anchor==null){
            window.scroll(0,0);
            this.logService.consoleLog('2', "PC CO Ojo: 0.0");
          }
      }
    });
  }
  */

  ngOnDestroy() {
    //Esta técnica de this._onDestroy$ en ngOnDestroy
    //permite liberar todos los Observables que tengan un .takeUntil(this._onDestroy$)
    //Si un Observable tiene take(n) no requiere destruirse porque ya lo hace luego de leer n veces
    this._onDestroy$.next();
    this._onDestroy$.complete();
  }
}
